import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import Form from "../../components/StaticPageForm";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { localizedTextDefaultValue } from "../../constants/localizedTextDefaultValue";
import {
  UpdateLandingDto,
  LocalizedText,
} from "../../services/generated/client";
import {
  upsertLanding,
  getLanding,
} from "../../services/landing/landingServices";
import styles from "./styles.module.css";
import { useApi } from "../../services/api";

const LandingPageText = () => {
  const { withErrorHandling } = useApi();
  const [landing, setLanding] = useState<UpdateLandingDto>({
    header: localizedTextDefaultValue,
    paragraph: localizedTextDefaultValue,
    explore: localizedTextDefaultValue,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [languageEditing, setLanguageEditing] =
    useState<keyof LocalizedText>("ka");

  useEffect(() => {
    const fetchLandingData = async () => {
      try {
        const response = await getLanding();
        if (response) {
          setLanding(response);
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchLandingData();
  }, []);

  const handleUpdateLanding = async (e: FormEvent) => {
    e.preventDefault();

    const { header, paragraph, explore } = landing;

    const newLanding = await withErrorHandling(async () => {
      return await upsertLanding({
        header,
        paragraph,
        explore,
      });
    });
    if (newLanding) {
      setLanding(newLanding);
    }
  };

  const handleMultiLanguageInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const id = e.target.id as keyof UpdateLandingDto;
    const value = e.target.value;

    setLanding((prev) => ({
      ...prev,
      [id]: {
        ...(prev[id] as LocalizedText),
        [languageEditing]: value,
      },
    }));
  };

  if (isLoading) {
    return <div className={styles.mainContent}>Loading...</div>;
  }

  return (
    <div className={styles.mainContent}>
      <div className={styles.formConteiner}>
        <div className={styles.formWrapper}>
          <LanguageSwitcher
            languageEditing={languageEditing}
            setLanguageEditing={setLanguageEditing}
            inForm={true}
          />
          <Form
            title={"Edit Landing Page"}
            submitLabel={"Update"}
            onSubmit={handleUpdateLanding}
            isView={false}
            languageEditing={languageEditing}
            fields={[
              {
                id: "header",
                label: `Header ${languageEditing.toUpperCase()}`,
                type: "text",
                value:
                  landing?.header?.[languageEditing as keyof LocalizedText] ||
                  "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
              {
                id: "paragraph",
                label: `Paragraph ${languageEditing.toUpperCase()}`,
                type: "textarea",
                value:
                  landing?.paragraph?.[
                    languageEditing as keyof LocalizedText
                  ] || "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
              {
                id: "explore",
                label: `Explore ${languageEditing.toUpperCase()}`,
                type: "text",
                value:
                  landing?.explore?.[languageEditing as keyof LocalizedText] ||
                  "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default LandingPageText;
